import React, { HTMLAttributes, Ref } from 'react';

import { Divider } from '@mui/material';

import classes from './ListboxComponent.module.scss';
import { AddNewFilterButton } from '../AddNewFilterButton/AddNewFilterButton';

type ListboxComponentProps = HTMLAttributes<HTMLElement> & {
  ref: Ref<HTMLUListElement>;
};

const ListboxComponent = ({
  children,
  onMouseDown,
  ref,
  ...props
}: ListboxComponentProps) => {
  return (
    <div onMouseDown={onMouseDown}>
      <ul {...props} ref={ref}>
        {children}
      </ul>
      <Divider className={classes.separatorLine} />
      <AddNewFilterButton />
    </div>
  );
};

export { ListboxComponent };
